/* eslint-disable */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import withRouter from '../../hooks/withRouter';
import API from '../../network';
import {
  CompletedInterviewsListRequestBody,
  CompletedInterviewsListValues,
  CompletedInterviewsProps,
  CompletedInterviewsState,
  CompletedInterviewsViewRendererProps,
} from './types';
import ViewRenderer from './views';
import { CurrentInterviewsFeedback } from '../CurrentInterviews/components';
import { CurrentInterviewsFiltersSubmitHandler } from '../CurrentInterviews/components/CurrentInterviewsFilters';
import moment from 'moment';
import { PaginationState } from '@tanstack/react-table';

class CompletedInterviews extends Component<CompletedInterviewsProps, CompletedInterviewsState> {
  constructor(props: CompletedInterviewsProps) {
    super(props);

    this.state = {
      completedInterviewsFetching: false,
      completedInterviews: [],
      filters: {
        pagination: {
          pageIndex: 0,
          pageSize: 20,
          totalRecords: 0,
        },
      },
    };
  }

  componentDidMount(): void {
    this.getCompletedInterviewsList();
  }

  onApplyFilter = (data: CurrentInterviewsFiltersSubmitHandler) => {
    const { filters } = this.state;
    const { values } = data;

    const {
      dateRange, searchQuery, clients, interviewType, 
      jobIds, recruiter, interviewer, status, 
    } = values;

    const startDate = dateRange?.startDate ? moment(dateRange?.startDate).format('MM/DD/YYYY') : undefined;
    const endDate = dateRange?.endDate ? moment(dateRange?.endDate).format('MM/DD/YYYY') : undefined;
    const searchText = searchQuery;
    const clientId = clients ? [clients] : undefined;
    const interviewMode = interviewType
    const jobId = jobIds;
    const recruiterId = recruiter;
    const interviewerId = interviewer;
    const interviewStatus = status;

    this.setState(
      {
        completedInterviews: [],
        filters: {
          ...filters,
          interviews: {
            startDate,
            endDate,
            searchText,
            clientId,
            interviewMode,
            jobId,
            recruiterId,
            interviewerId,
            interviewStatus
          },
        },
      },
      () => {
        this.getCompletedInterviewsList();
      },
    );
  };

  onFiltersReset = () => {
    const { filters, completedInterviewsFetching } = this.state;
    if (completedInterviewsFetching) {
      return;
    }
    this.setState({
      filters: {
        ...filters,
        interviews: {},
      },
      completedInterviews: [],
    }, () => {
      this.getCompletedInterviewsList();
    });
  };

  getCompletedInterviewsList = async () => {
    this.setState({
      completedInterviewsFetching: true,
      completedInterviews: [],
    });
    const { filters } = this.state;
    const { pagination, interviews } = filters;

    const requestBody: CompletedInterviewsListRequestBody = {
      page: pagination.pageIndex,
      size: pagination.pageSize.toString(),
      ...interviews,
    };
    try {
      const completedInterviewsList = await API.getInstance().getCompletedInterviews(requestBody);
      this.setState({
        completedInterviews: completedInterviewsList?.completedInterviews,
        filters: {
          ...filters,
          pagination: {
            ...filters.pagination,
            totalRecords: completedInterviewsList?.totalElements,
          },
        },
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        completedInterviewsFetching: false,
      });
    }
  };

  onChangePagination = (data: PaginationState) => {
    const { filters } = this.state;
    this.setState(
      {
        filters: {
          ...filters,
          pagination: { ...filters.pagination, ...data },
        },
      },
      () => {
        this.getCompletedInterviewsList();
      },
    );
  };

  onUpdateInterviewStatus = async (request: any, close: (() => void) | undefined) => {
    try {
      // this.setState({
      //   loading: true,
      // });
      await API.getInstance().updateInterviewStatus(request);
      await confirmWrapper('Feedback submitted successfully.', {
        variant: 'success',
        autoClose: true,
        primaryBtnLabel: 'ok',
        hideSecondaryBtn: true,
      });
      if (close) close();
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      // this.setState({
      //   loading: false,
      // });
    }
  };

  onFeedback = async (data: CompletedInterviewsListValues) => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <CurrentInterviewsFeedback
          defaultValues={data}
          onSave={this.onUpdateInterviewStatus}
        />
      ),
    });
  };

  getProps = (): CompletedInterviewsViewRendererProps => {
    const {
      completedInterviewsFetching,
      completedInterviews,
      filters,
    } = this.state;

    return {
      completedInterviewsFetching,
      completedInterviews,
      filters,
      onFeedback: this.onFeedback,
      onApplyFilter: this.onApplyFilter,
      onFiltersReset: this.onFiltersReset,
      onChangePagination: this.onChangePagination,
      onUpdateInterviewStatus: this.onUpdateInterviewStatus,
    };
  };

  render() {
    const viewProps: CompletedInterviewsViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(CompletedInterviews);
